/**
 * GeometryInstance3D parser: the VisualInstance3D fields plus the instance state, which every
 * GeometryInstance3D leaf parser starts from. An unreadable value keeps Godot's default.
 */
import { parseNonEmptyAabb, parseOptionalFloat, parseOptionalInt } from '../../../parser/valueParsers';
import { parseVisualInstance3D } from '../visualinstance3d/parser';
import { GEOMETRY_INSTANCE_DEFAULTS } from './types';
export function parseGeometryInstance3D(heading, properties) {
    return {
        ...parseVisualInstance3D(heading, properties),
        transparency: parseOptionalFloat(properties.transparency) ?? GEOMETRY_INSTANCE_DEFAULTS.transparency,
        castShadow: parseOptionalInt(properties.cast_shadow) ?? GEOMETRY_INSTANCE_DEFAULTS.castShadow,
        visibilityRange: parseVisibilityRange(properties),
        customAabb: parseNonEmptyAabb(properties.custom_aabb, 'custom_aabb'),
    };
}
function parseVisibilityRange(properties) {
    const fallback = GEOMETRY_INSTANCE_DEFAULTS.visibilityRange;
    return {
        begin: parseOptionalFloat(properties.visibility_range_begin) ?? fallback.begin,
        beginMargin: parseOptionalFloat(properties.visibility_range_begin_margin) ?? fallback.beginMargin,
        end: parseOptionalFloat(properties.visibility_range_end) ?? fallback.end,
        endMargin: parseOptionalFloat(properties.visibility_range_end_margin) ?? fallback.endMargin,
        // `set_visibility_range_fade_mode` stores any value (`visual_instance_3d.cpp:285-289`).
        fadeMode: (parseOptionalInt(properties.visibility_range_fade_mode) ??
            fallback.fadeMode),
    };
}
//# sourceMappingURL=parser.js.map